(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('UrgentIssueAlertController', UrgentIssueAlertController);

    UrgentIssueAlertController.$inject = ['$scope', '$state', '$q', '$filter', 'CoreService', 'UrgentIssues'];

    function UrgentIssueAlertController($scope, $state, $q, $filter, CoreService, UrgentIssues) {
        var vm = this;

        vm.title = 'Urgent Issue Alert';
        vm.entityClassHumanized = 'Urgent Issue Alert';
        vm.urgentIssues = [];
        vm.searchQuery = "";

        vm.search = search;

        init();

        function init() {
            UrgentIssues.filter({
                facilityId: CoreService.getCurrentFacility().id,
                searchQuery: vm.searchQuery
            }, function (urgentIssues) {
                vm.urgentIssues = _.chain(urgentIssues)
                    .groupBy("chart.id")
                    .map(function (urgentIssues, chartId) {
                        return {
                            chart: urgentIssues[0].chart,
                            chartId: chartId,
                            urgentIssues: urgentIssues
                        };
                    })
                    .orderBy("fullName")
                    .value();
            });
        }

        function search() {
            init();
        }
    }
})();
